import React from "react";
import "./whatIsLeague.css";

function WhatIsLeague() {
  return (
    <div className="whatIsLeague">
      <div className="whatIsLeagueBox">
        <div className="title">What is The Impact League?</div>
        <div className="whatIsLeagueAns">
          Leagues are primarily step challenges exclusively for employees or
          members of an organization. It is an exciting way to build healthy
          habits while engaging people in doing good.
        </div>
      </div>
    </div>
  );
}

export default WhatIsLeague;
